/** Keep apply overlays visible at least this long to avoid flicker. */
export const MIN_APPLY_VISIBLE_MS = 450;

/**
 * End an apply loading state, waiting out the minimum visible duration if needed.
 * Optional onDone runs when loading actually ends (after any delay).
 */
export function finishApplyLoading(startedAt, setIsProcessing, timerRef, onDone) {
  const complete = () => {
    setIsProcessing(false);
    onDone?.();
  };
  const remaining = Math.max(0, MIN_APPLY_VISIBLE_MS - (Date.now() - startedAt));
  if (timerRef?.current) clearTimeout(timerRef.current);
  if (remaining === 0) {
    complete();
    return;
  }
  timerRef.current = setTimeout(() => {
    timerRef.current = null;
    complete();
  }, remaining);
}
